import React from "react";
import {
  facebookShareLink,
  twitterShareLink,
  whatsappShareLink,
  WEB_BASE_URL,
} from "../utils/helper";
export default function Share({ closeShare, shareUrl }) {
  let quote = "";
  let title = "";
  shareUrl = shareUrl;
  var facebookLink =
    facebookShareLink +
    "&link=" +
    encodeURIComponent(shareUrl) +
    "&quote=" +
    encodeURIComponent(quote) +
    "&www.facebook.com=1";

  var twitterLink =
    twitterShareLink +
    encodeURIComponent(quote + " \n\n" + shareUrl) +
    "&www.facebook.com=1";

  const share = () => {
    try {
      let obj = {};
      window.gtag("event", ` Shared`, obj);
    } catch (error) {}
  };
  console.log("shareUrl", shareUrl);
  return (
    <div className="share_popup">
      <div className="share_popup_ps">
        <h4>
          Share link now{" "}
          <img
            src="/assets/images/cross.svg"
            className="close_share_modal"
            onClick={() => {
              closeShare();
            }}
          />
        </h4>
        <div className="share_icons">
          <ul>
            <li>
              <a
                href={facebookLink}
                target="_blank"
                rel="noreferrer"
                // onClick={() => {
                //   share();
                // }}
              >
                <img src="/assets/images/facebook.svg" className="" />
              </a>
            </li>

            <li>
              <a href={twitterLink} target="_blank" rel="noreferrer">
                <img
                  src="/assets/images/twiiterblack.svg"
                  className=""
                  // onClick={() => {
                  //   share();
                  // }}
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
